module.exports = __webpack_public_path__ + "img/italy-logo-icon.aa73b944.png";